angular
	.module('boyds')
	.config(['ngToastProvider', function(ngToast) {
		ngToast.configure({
			verticalPosition: 'bottom',
			horizontalPosition: 'right',
			maxNumber: 2,
			animation:'slide'
		});
	}]);